import React from 'react'
import { Row, Container } from 'react-bootstrap';
import './casestudybody28.css';

import clientimg from '../images/case-study-client28.webp'
import outcome from '../images/outcome28.webp'

import sm1 from '../images/cs28so1.webp'
import sm2 from '../images/cs28so2.webp'
import sm3 from '../images/cs28so3.webp'
import sm4 from '../images/cs28so4.webp'



const Casestudybody28 = () => {

    return (
        <>
        <section className='casestudybody28-section'  >
          <Container>

            <Row className='w-100 py-md-5 py-4 clintrow'>
                <div className='col-md-4 relative order-1'>
                  <div className='left-box'>
                    <div className='content-box'>
                      <h2>About</h2>
                      {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                      <div className="h1">The Client</div>
                      <p className='anima '><span className='only-anima-underline' > **** </span></p>
                      <p>A FinTech Company, that enables investors to invest in Institutional Grade Real Estate properties through a Crowdfunding Platform</p>
                    </div>
                  </div>
                           
                </div>
                <div className='col-md-8 right-box'>
                    <img src={clientimg} alt="" />
                </div>
            </Row>
       
            <Row className='mt-md-5'>
              <div className='col-md-12'>
                <div className='content-box'>
                  <h2>Situation</h2>
                  {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                  <div className="h1">Overview</div>
                  <p className='anima '><span className='only-anima-underline' > **** </span></p>
                  <p>The client's objectives were to create a comprehensive business plan and a robust Go-To-Market strategy for the firm to secure approval from the regulatory authorities</p>
                </div>
                
              </div>
            </Row>
          </Container>
        </section>
    
        <section className='casestudybody28-section bg-gredient-dark'>
          <Container>
            <Row>
              <div className='col-md-12'>
                  <div className='content-box'>
                    <h2>Approach &</h2>
                    {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                    <div className="h1">Methodology</div>
                    <p className='anima '><span className='only-anima-underline' > **** </span></p>
                    {/* <p>The next step was to put together and implement a step-by-step process for conducting the valuation:</p> */}
                  
                    <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>
                        <div className='text'>
                          <h4>Internal Assessment:</h4>
                          <p>Thoroughly <span style={{color:"#01C6B2"}}>analyzed the firm's capabilities, key success factors, organizational structure, and investment criteria,</span> and performed stakeholder mapping for a comprehensive internal assessment </p>
                        </div>
                      </div>
    
                      <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>
                        <div className='text'>
                          <h4>Market Assessment:</h4>
                          <p>Conducted a <span style={{color:"#01C6B2"}}>robust real estate market assessment</span>, provided a crowdfunding industry overview and identified the target addressable market, competition analysis, and market opportunity analysis to better understand market dynamics</p>
                        </div>
                      </div>
    
                      <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>

                        <div className='text'>
                          <h4>Business Model:</h4>
                          <p><span style={{color:"#01C6B2"}}>Mapped out a series of sequential steps involving all stakeholders,</span> highlighting the entry and exit routes for investors, as well as the corresponding fees associated with each step, using a flowchart</p>
                        </div>
                      </div>

                      <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>

                        <div className='text'>
                          <h4>Process Flows:</h4>
                          <p>Formulated the <span style={{color:"#01C6B2"}}>onboarding and deal screening process</span> for investors/real estate owners and conducted due diligence of the firm</p>
                        </div>
                      </div>                 

                      <div className='list-text last-child my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>

                        <div className='text'>
                          <h4>Go-To- Market Strategy:</h4>
                          <p>Based on the above assessment, <span style={{color:"#01C6B2"}}>developed a well-crafted GTM strategy</span> that was aligned with the firm's short-term, medium-term, and long-term objectives</p>
                        </div>
                      </div> 
                     
                      <h3 className='mt-5'>Sample Output</h3>
                      <div className='sample-output mt-3'>
                        <img src={sm1} alt=''/>
                        <img src={sm2} alt=''/>
                        <img src={sm3} alt=''/>
                        <img src={sm4} alt=''/>
                      </div>
                  </div>
                  
                </div>
            </Row>
          </Container>
        </section>

    
        <section className='casestudybody28-section outcome'  >
          <Container>
            <Row className='w-100 pb-5 clintrow '>
                <div className='col-md-4 relative order-1'>
                  <div className='left-box'>
                    <div className='content-box'>
                      <div className="h1">Outcome</div>
                      <p className='anima '><span className='only-anima-underline' > **** </span></p>
                      <p>The business plan and GTM framework enabled  the client to successfully achieve government approval and secure significant funding through comprehensive planning and diligent execution, enabling accelerated business growth</p>  
                    </div>
                  </div>
                           
                </div>
                <div className='col-md-8 right-box'>
                    <img src={outcome} alt="" />
                </div>
            </Row>
       
          </Container>
        </section>
    
        </>  
      )
    }

export default Casestudybody28
